export default __webpack_public_path__ + "static/media/608.38a71a1b.png";